import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';

import { NDT_SNACK_BAR_DATA } from './snack-bar-config';
import { NdtSnackBarRef } from './snack-bar-ref';

/**
 * Interface for a simple snack bar component that has a message and a single action.
 */
export interface TextOnlySnackBar {
  data: { message: string; action: string };
  snackBarRef: NdtSnackBarRef<TextOnlySnackBar>;
  action: () => void;
  hasAction: boolean;
}

@Component({
  selector: 'simple-snack-bar',
  templateUrl: 'simple-snack-bar.html',
  exportAs: 'ndtSnackBar',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'ndt-mdc-simple-snack-bar',
  },
})
export class SimpleSnackBar implements TextOnlySnackBar {
  constructor(
    public readonly snackBarRef: NdtSnackBarRef<SimpleSnackBar>,
    @Inject(NDT_SNACK_BAR_DATA) public readonly data: { message: string; action: string },
  ) {}

  /** Performs the action on the snack bar. */
  action(): void {
    this.snackBarRef.dismissWithAction();
  }

  /** If the action button should be shown. */
  get hasAction(): boolean {
    return !!this.data.action;
  }
}
